import { TabType, UserPasswordData } from './types';
import { GeneralTab } from './Tabs/GeneralTab';
import { SSOSettings } from './Tabs/SSOSettings';
import { PwdStrategySettings } from './Tabs/PwdStrategySettings';

type SwitcherProps = {
  currentTab: TabType;
  userAndPwdSettings: UserPasswordData;
};

const TabSwitcher = ({ currentTab, userAndPwdSettings }: SwitcherProps) => {
  switch (currentTab) {
    case TabType.SSO_SETTINGS:
      return <SSOSettings userAndPwdSettings={userAndPwdSettings} />;
    case TabType.PWD_STRATEGY_SETTINGS:
      return <PwdStrategySettings userAndPwdSettings={userAndPwdSettings} />;
    default:
      return <GeneralTab userAndPwdSettings={userAndPwdSettings} />;
  }
};

export default TabSwitcher;
